import { Chip } from "@mui/material";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import DataTable from "../../components/enterprise/DataTable";
import { analyticsTabs } from "../navigation";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const rows = [
  { model: "YOLO inference", latency: "48 ms", queue: 3, status: "Preview" },
  { model: "Action Recognition", latency: "112 ms", queue: 5, status: "Preview" },
  { model: "ReID", latency: "71 ms", queue: 1, status: "Preview" },
];

const AiPerformancePage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.aiPerformance.title")} subtitle={t("platform.pages.aiPerformance.subtitle")} breadcrumbs={[t("platform.nav.analytics"), t("platform.tabs.ai")]} tabs={analyticsTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <DataTable
          columns={[
            { key: "model", header: t("platform.common.service") },
            { key: "latency", header: t("platform.common.latency") },
            { key: "queue", header: t("platform.common.queue") },
            { key: "status", header: t("platform.common.status"), render: (row) => <Chip size="small" label={row.status} color="info" variant="outlined" /> },
          ]}
          rows={rows}
        />
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledAnalyticsDescription")} />
      )}
    </ModuleLayout>
  );
};

export default AiPerformancePage;
